import { global } from '@/global';
import store from "@/store";

export function getToken() {
	return sessionStorage.getItem(global['ACCESS_TOKEN']);
}

export function isLogin() {
	let token = getToken();

	return !!token

	// if (!token) return false

	// let _token = JSON.parse(atob(token.split('.')[1]));

	// let date = new Date();
	// let time = date.getTime();

	// let status = _token.exp * 1000 > time;

	// return status
}

export function checkAuth(to, from, next) {

	if (isLogin()) {
		return next();
	} else {
		store
			.dispatch("logout")
		store
			.dispatch("deletechat")
			.then(() => next({ name: "login" }));

	}
}

